import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "../../components/admin/AdminLayout";
import { CheckCircle, Warning, XCircle, ArrowsClockwise } from "@phosphor-icons/react";

export default function AdminHealth() {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchHealth() {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/health`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("rs_token")}` },
      });
      if (!res.ok) throw new Error("Failed");
      setHealth(await res.json());
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchHealth(); }, []);

  const StatusBadge = ({ status, label }) => {
    const icon = status === "connected" || status === "healthy" ? <CheckCircle size={16} weight="fill" /> :
                 status === "degraded" ? <Warning size={16} weight="fill" /> :
                 <XCircle size={16} weight="fill" />;
    const color = status === "connected" || status === "healthy" ? "text-green-600 bg-green-50" :
                  status === "degraded" ? "text-yellow-600 bg-yellow-50" :
                  "text-red-600 bg-red-50";
    return (
      <div className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-bold ${color}`}>
        {icon}{label}: {status}
      </div>
    );
  };

  return (
    <AdminLayout>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="text-sm text-[var(--ink-muted)]">
            Last checked: {health?.timestamp ? new Date(health.timestamp).toLocaleString() : "-"}
          </div>
          <button onClick={fetchHealth} disabled={loading} className="btn-pop text-sm flex items-center gap-1.5">
            <ArrowsClockwise size={14} className={loading ? "animate-spin" : ""} /> Refresh
          </button>
        </div>

        <div className="grid lg:grid-cols-2 gap-4">
          <div className="card-pop p-4 space-y-3">
            <h3 className="font-bold">Backend</h3>
            <StatusBadge status={health?.backend?.status} label="API" />
            <div className="text-xs text-[var(--ink-muted)]">Version: {health?.backend?.version || "unknown"}</div>
          </div>
          <div className="card-pop p-4 space-y-3">
            <h3 className="font-bold">Database</h3>
            <StatusBadge status={health?.database?.status} label="Supabase DB" />
            {health?.database?.error && <div className="text-xs text-red-600">{health.database.error}</div>}
          </div>
          <div className="card-pop p-4 space-y-3">
            <h3 className="font-bold">Authentication</h3>
            <StatusBadge status={health?.auth?.status} label="Supabase Auth" />
            {health?.auth?.error && <div className="text-xs text-red-600">{health.auth.error}</div>}
          </div>
          <div className="card-pop p-4 space-y-3">
            <h3 className="font-bold">Storage</h3>
            <StatusBadge status={health?.storage?.status} label="Supabase Storage" />
            {health?.storage?.buckets && (
              <div className="text-xs text-[var(--ink-muted)]">Buckets: {health.storage.buckets.join(", ")}</div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}